/**
 * "Is Social Security Number" — the format rule a patient-facing input can carry.
 *
 * THE RULE (the SSA's own never-issued ranges, nothing cleverer):
 *   - blank passes: a format rule says "if you type something it has to look like this";
 *     only `required` says a field must be filled.
 *   - a value containing a LETTER fails outright. Stripping punctuation out of "none" or
 *     "n/a" would leave an empty string, and an empty string is not a Social Security
 *     Number the patient meant to type — it is a patient telling us they have none.
 *   - otherwise dashes / spaces / dots are ignored, and exactly 9 digits must remain.
 *   - area (first 3) is never 000, never 666, never 900-999.
 *   - group (middle 2) is never 00. Serial (last 4) is never 0000.
 *   - 078-05-1120 (the 1938 Woolworth wallet card) and 219-09-9999 (a 1962 ad) were never
 *     issued and are the two numbers people type from memory as a "test SSN".
 *
 * ⛔ IMPORT-FREE ON PURPOSE — cypress/node-tests/validation.test.js loads and executes
 * THIS EXACT FILE rather than mirroring it. Keep it dependency-free.
 *
 * @param {any} fieldValue
 * @return {boolean}
 */
export default function isSsnRule(fieldValue) {
    if (fieldValue === null || fieldValue === undefined) {
        return true
    }

    const asString = String(fieldValue)
    if (asString.trim() === '') {
        return true
    }

    // "none", "n/a", "ask me" — text, not a mistyped number.
    if (/[a-z]/i.test(asString)) {
        return false
    }

    const digits = asString.replace(/\D/g, '')
    if (digits.length !== 9) {
        return false
    }

    const area = digits.slice(0, 3)
    const group = digits.slice(3, 5)
    const serial = digits.slice(5)

    if (area === '000' || area === '666' || area.charAt(0) === '9') {
        return false
    }
    if (group === '00') {
        return false
    }
    if (serial === '0000') {
        return false
    }

    // Never issued — famous "example" numbers.
    if (digits === '078051120' || digits === '219099999') {
        return false
    }

    return true
}
